// extracted by mini-css-extract-plugin
export default {"two-column-list":"TemplateSelectionPopup_two-column-list__rYUrJ"};